import PlatformPage from '../PlatformPage';

const ForWebflow = () => (
  <PlatformPage
    slug="webflow"
    name="Webflow"
    title="Website Feedback Tool for Webflow"
    description="Visual feedback on your live Webflow site. One snippet in Site settings; works with CMS pages, Ecommerce and page transitions. Invisible to visitors."
    h1="Website feedback tool built for Webflow sites."
    intro="Paste one line into your site’s custom code, publish, and your team can click on any element of the live site to leave a note pinned to that exact spot. Static pages, CMS collections, Ecommerce templates, and sites with animated page transitions."
    requirement="Site-wide custom code on Webflow needs an active Site plan (or a paid Workspace)."
    steps={[
      { title: 'Copy your snippet from the Cayda dashboard', desc: 'One script tag with your site’s token.' },
      { title: 'Open Site settings → Custom code', desc: 'In the Webflow Designer, the gear icon in the left panel.' },
      { title: 'Paste into Footer code and save', desc: 'Site-wide, not a single page’s custom code, which only loads on that page.' },
      { title: 'Publish', desc: 'Custom code runs on the published site, not in the Designer preview.' },
    ]}
    stepsNote="Reviewing before launch? Add your webflow.io staging domain and your custom domain as separate sites in Cayda so notes stay organised per environment."
    loads={{
      title: 'Built for how Webflow pages load',
      paragraphs: [
        'Standard Webflow navigation does a full page load, so the script runs fresh on every page. Sites that use Barba.js or Swup for animated transitions swap content without reloading; Cayda listens for those transition events, cleans up the previous page’s notes and loads the right ones for the new URL, so it stays active on heavily customised builds.',
        'CMS collection pages, Ecommerce product and category templates, and pages with interactions all work the same way. A note pins to the element, not a coordinate, so it survives layout shifts and responsive breakpoints.',
      ],
    }}
    where={{
      title: 'Where your team leaves notes',
      paragraphs: [
        'A heading that wraps badly at tablet width, a CMS item missing its image, a button whose hover state never fires, copy a client wants changed. Click it, type, done. Every note carries a screenshot, the page URL, browser, OS and viewport, so the designer opens exactly the state the reviewer saw.',
        'Notes have a type, status, priority and assignee and live in a Kanban or list dashboard across every site you manage. Studios running several Webflow clients keep each as its own site with its own collaborators, and on the Team plan clients review through guest links without a member fee.',
      ],
    }}
    extras={[
      {
        title: 'Invisible to your visitors',
        paragraphs: [
          'The script activates only for authenticated team members and invited guests. For everyone else it renders nothing, sets no cookies and adds no meaningful weight, so it belongs on the live site, not a duplicate.',
        ],
      },
    ]}
    ctaTitle="Add feedback to your Webflow site."
    ctaSub="Paste the snippet, publish, and start leaving notes in under two minutes."
  />
);

export default ForWebflow;
